export default __webpack_public_path__ + "static/media/mp3.44c4b8b9.svg";